import React , {useState} from "react";
import { Box, Button, LinearProgress, Tooltip } from "@mui/material";
import { AddPhotoAlternate, Download, CancelPresentation as CloseIcon } from "@mui/icons-material";
import { grey} from '@mui/material/colors';
import { ReactComponent as FlyIcon } from './logo.svg'
import { useColorMode } from "../ColorModeContext";
import { useComfy } from "../comfy/ComfyProvider";
import { color } from "framer-motion";



interface PreviewPanelProps {
  image: string | null;
  base: string;
  rand: number;
  inProgress: boolean;
  progress: number;
  addToGallery: () => void;
  queue: number;
  
}



const PreviewPanel: React.FC<PreviewPanelProps> = ({
  image,
  base,
  rand,
  inProgress,
  progress,
  addToGallery,
  queue,
  
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {colorMode} = useColorMode();
  const { outputImage, jobStatus } = useComfy();

  return (
    <div className= {colorMode ? "MiddlePanelContainerDark" : "MiddlePanelContainerLight" }>

      {/* Title */}
      <div style={{ display: "flex", flexDirection: "column", alignContent: "left", width: "100%", top: 20, position: "absolute" }}>
        <div className="Title">
          <h1 className={colorMode?"TopNumberDark":"TopNumberLight"}>4</h1>
          <h1 className="Title"> Preview</h1>
        </div>
        <h4 className="SubTitle" style={{marginBottom:0}}>Current render</h4>
        {/** add queue via status message here...
         * 
         * Requests in queue(message)
        
         <h5 style={{margin:0}}>Requests in queue: {queue}</h5>
          */}
      </div>
      
      
      <Box sx={{position:"absolute", top:100, width:'100%', pr:'40px', maxHeight: '60vh' ,objectFit:'cover'}}>
      {/* Thumbnail Image with Click Event */}
      {outputImage ? (
        <img
          src={outputImage}
          alt="Generated"
          style={{ borderRadius: "10px", cursor: "pointer", width: "100%", maxHeight: '60vh' , objectFit:'cover' }}
          onClick={() => setIsOpen(true)}
        />
      ) : (
        
        <div >
        <img 
          src={base}
          alt="Preview"
          style={{ 
            borderRadius: "10px", 
            width: "100%", 
            cursor: "pointer", 
            maxHeight: '60vh', 
            opacity:.8,
            objectFit:'cover',
          }}
          onClick={() => setIsOpen(true)}

        />
        
        </div>
       
      )}

      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          {/* Close button */}
          <button
            onClick={() => setIsOpen(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "white",
              fontSize: "24px",
            }}
          >
            <CloseIcon sx={{fontSize:"40pt"}}/>
          </button>

          <img
            src={outputImage ? outputImage : base}
            alt="Full Screen"
            style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "10px" }}
          />
        </div>
      )}
      {/* Image preview */}



      <Box sx={{display:'flex', flexDirection:'row', alignItems:"center"}}>

      {/* Save image button */}
      <Button
        variant="contained"
        sx={{  p: "15px", width: "100%", position: "relative", height:'5vh', backgroundColor:colorMode?grey[800]:grey[300], '&:hover': {
          backgroundColor:colorMode?grey[900]:grey[400]} }}
        onClick={() => {
          const imageUrl = outputImage ? outputImage : base;
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = outputImage ? `render-${Date.now()}.png` : "preview.png"; // Dynamic filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        <Download sx={{ mr: "20px", color: colorMode? grey[400]:grey[900] }} />
        <h4 style={{ margin: "0", padding: "0", color: colorMode? grey[400]:grey[900] }}> Save this render </h4>
      </Button>

            {/* Add to the gallery */}
      <Tooltip title="Add this render to the gallery" placement="right" arrow>
        <Button
          variant='contained'
          onClick={addToGallery}
          sx={{ p: "15px", m:'.4vh ', color: colorMode? grey[400]:grey[900], height:'5vh',backgroundColor:colorMode?grey[800]:grey[300], '&:hover': {
             backgroundColor:colorMode?grey[900]:grey[400]},}} >
          <AddPhotoAlternate />
        </Button>
      </Tooltip>

      
      </Box>
                  {/* Progress bar */}
                  <Box sx={{ width: "100%" }}>
        {jobStatus === "IN_PROGRESS" && <h5 className="SubTitle" style={{ marginTop: "30px" }}>Generating...</h5>}
        {jobStatus === "IN_QUEUE" && <h5 className="SubTitle" style={{ marginTop: "30px" } }>In queue...</h5>}
        {jobStatus === "IN_QUEUE" && (
    <LinearProgress
        variant={jobStatus === "IN_QUEUE" ? "indeterminate" : "determinate"}
        value={ jobStatus === "IN_QUEUE"  ? undefined : progress}
        sx={{ marginBottom: "10px", borderRadius: "10px" }}
        color="secondary"
    />
)} 
        {jobStatus === "IN_PROGRESS" && (
    <LinearProgress
        variant={jobStatus === "IN_PROGRESS" ? "indeterminate" : "determinate"}
        value={jobStatus === "IN_PROGRESS"  ? undefined : progress}
        sx={{ marginBottom: "10px", borderRadius: "10px" }}
    />
)}        
      </Box>
      </Box>
      </div>
  );
};

export default PreviewPanel;
